import React from 'react'

import Map from './Map/Map'
import MainControl from './Controls'
import SettingsPanel from './Controls/settings-panel'
import ApiKeyModal from './components/ApiKeyModal'
import AppInitializer from './components/AppInitializer'

class App extends React.Component {
  render() {
    return (
      <div>
        <AppInitializer />
        <Map />
        <MainControl />
        <SettingsPanel />
        <ApiKeyModal />
      </div>
    )
  }
}

export default App
